import { createContainer } from "unstated-next";
import useToggle from "@sprout/hooks/dist/useToggle";
const JumpTo = createContainer(useToggle);
export const useJumpTo = JumpTo.useContainer;
export const JumpToProvider = JumpTo.Provider;
